// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1elN_","emails":"CreateEditClinics_emails__3ZNAa","emailTagLabel":"CreateEditClinics_emailTagLabel__2tZlz"};